export default __webpack_public_path__ + "static/media/molen.9b25dccc.png";